import { SanityFullWidthTextBlock } from '../../types/generated/graphql-types'
import { FullWidthTextBlockProps } from '../components/blocks/FullWidthTextBlock'
import { notEmpty } from '../utilities/filters'

export const mapSanityFullWidthTextBlockProps = ({
  title,
  preamble,
  _rawBody,
}: SanityFullWidthTextBlock): FullWidthTextBlockProps => ({
  title: title ?? '',
  preamble: preamble ?? '',
  body: _rawBody?.filter(notEmpty) ?? [],
})
